import agent from "../../api/agent";
export const login = (email, password) =>
  agent.requests.post(`/Admin/login`, { userName:email, password });

  export const forgetPassword = (email) =>
  agent.requests.post(`/Admin/forgetPassword?email=${email}`);

  export const resetPassword = (email,token, newPassword) =>
    agent.requests.post(`/Admin/resetPassword`, { email, newPassword,token });